import React from 'react'

export default props => (
    <div className='row' style={{ ...props.style, justifyContent: props.alignCenter ? 'center' : (props.alignRight ? 'flex-end' : 'left') }}>
		{props.children}
	</div>
)
